import React from "react";

import { validLandline } from "@origin-digital/validation";
import { pageRoutes } from "src/consts";
import { UpdatePhone } from "../UpdatePhone";

import { FieldUpdateHook } from "../../../crm/profileFieldMap";
import { ProfileFieldMapTypes } from "../../../crm/profileFieldMapContextHelpers";
import content from "./content.json";

export const UpdateLandlineScreen: React.FC<{
  landline: string | null;
  useUpdate: FieldUpdateHook<string>;
  type: ProfileFieldMapTypes;
}> = ({ landline, useUpdate, type }) => (
  <UpdatePhone
    value={landline}
    content={content}
    useUpdatePhone={useUpdate}
    updateSuccessRoute={pageRoutes.updateLandline.success}
    removeSuccessRoute={pageRoutes.updateLandline.removeSuccess}
    type="landline"
    validator={validLandline(content.phone.errors)}
    fieldMapType={type}
  />
);
